import { completePreviewQes as completePreviewQesAction } from '../../../redux/actions/esignature';

/**
 * Preview-only QES success: marks the document qualifiedSigned without
 * provider API / WebID / websocket. Consumers (withForms / withESignature)
 * react to documentIsQualifiedSigned as in production.
 */
export const dispatchCompletePreviewQes = (dispatch, docId) => {
  if (!window.previewMode || !docId) {
    return;
  }
  dispatch(completePreviewQesAction(docId));
};
